import React from 'react';

import Breadcumb from './Breadcumb';
import Steps from './Steps';
import WhyChoose from './WhyChoose';
import CallToaction from './CallToaction';

function Main() {
  return (
    <>
      <Breadcumb />
      <Steps />
      <WhyChoose />
      <CallToaction />
    </>
  );
}

export default Main;
